module.exports = __webpack_public_path__ + "img/3.699299fa.jpg";